export default "__VITE_ASSET__70e772f9__"